import * as layoutActions from "../../actions/layoutActions";
import * as ajax from "../../actions/ajaxCounterActions";
import * as exception from "../../actions/exceptionActions";

import StaticPageApi from "../../api/staticPageApi";

import { getStore } from "../../store/configureStore";
import * as beads from "../../actions/beadActions";

export default class BovenlokaliteitInfoPagePageHelper {

	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const dossierId = this.context.props.dossierId;
		this.getByDossierId(dossierId);
	}

	loadLayout(model) {
		const dossierId = this.context.props.dossierId;

		this.dispatch(layoutActions.loadBovenLokaliteitInfoPageLayout(model.naam, model.tabTitel, dossierId, model.typeDossier));
	}

	getByDossierId(dossierId) {
		this.dispatch(ajax.started());
		StaticPageApi.getByDossier(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.dispatch(beads.beadsLoaded(response.data.beadModels));
				this.loadLayout(response.data);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	isReadyToRender() {
		return true;
	}
}